'use strict';

(function () {
  'use strict';

  angular.module('msOnboarding').controller('SsoLandingCtrl', SsoLandingCtrl);

  SsoLandingCtrl.$inject = ['$sessionStorage', 'providerSvc', 'authenticationSvc', 'languageSvc', 'onboardingRouter', 'organization', 'authenticationRouter', '$timeout', 'countryGdprConfig', 'NotifyingSvc', '$window'];

  function SsoLandingCtrl($sessionStorage, providerSvc, authenticationSvc, languageSvc, onboardingRouter, organization, authenticationRouter, $timeout, countryGdprConfig, NotifyingSvc, $window) {
    var vm = this;
    var ssoAuthView = $sessionStorage.ssoAuthView;
    vm.customFormStep = false;
    vm.checkboxTerms = false;
    vm.isSubjectToGDPR = false;
    vm.gdprCheckboxAge = false;
    vm.gdprCheckboxEmailOptIn = false;
    vm.canNavigate = _canNavigate;
    vm.navigate = _navigate;
    vm.firstName = '';
    vm.passwordRequired = false;
    // TODO: remove isSkipTermsFeatureEnabled feature can become obsolete
    vm.isSkipTermsFeatureEnabled = false;
    vm.isProviderLoading = false;

    _init();

    function _init() {
      vm.isProviderLoading = true;
      vm.cobrandingText = organization.name;
      vm.countryGdprConfig = countryGdprConfig.getFromStorage();
      vm.isSubjectToGDPR = vm.countryGdprConfig.isSubjectToGDPR;
      vm.customFormStep = $sessionStorage.customFormStep;
      delete $sessionStorage.customFormStep;

      // Catch error from resolved organization
      if (organization.errorCode || !ssoAuthView || !ssoAuthView.attributesView) {
        onboardingRouter.navigateSsoError({
          contact: true
        });
        return;
      }

      NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.GET_AGREEMENTS, true);

      // set the language
      var languagePref = ssoAuthView.attributesView.language ? ssoAuthView.attributesView.language : 'en-US';
      languageSvc.setLanguage(languagePref, false);

      // Set firstName
      vm.firstName = ssoAuthView.attributesView.firstName ? ssoAuthView.attributesView.firstName : '';

      providerSvc.setProvider({
        accessCode: ssoAuthView.attributesView.accessCode,
        organization: organization.shortName
      }, true).then(function () {
        // Set options for provider preference based features
        providerSvc.getPreferences().then(function (resp) {
          vm.passwordRequired = _checkForSSOPasswordRequiredFeature(resp.features);
        });

        providerSvc.isFeatureEnabled('SSO_SKIP_TERMS_AND_CONDITIONS').then(function (enabled) {
          // TODO: remove isSkipTermsFeatureEnabled feature can become obsolete
          vm.isSkipTermsFeatureEnabled = enabled;
          vm.checkboxTerms = enabled;
          $timeout(function () {
            vm.isProviderLoading = false;
          }, 0);
        });
      });

      providerSvc.getHeader().then(function (data) {
        var contentItem = null;
        if (data && data.content) {
          contentItem = data.content.filter(function (headerContent) {
            return headerContent.target === 'image';
          })[0];
          if (contentItem) {
            vm.cobranding = contentItem.replacement;
          }
        }
      });

      vm.isHiddenTryMobileButton = _.get($window, 'MYSTRENGTH.config.platforms.web.features.hide_try_mobile_app_btn');
    }

    function _navigate() {
      var ssoAuthView = _updateSsoAuthView();

      // Do login
      authenticationSvc.ssoLogin(ssoAuthView).then(function () {
        //both returning and new users go to the next required step
        if (ssoAuthView.attributesView.redirectUrl) {
          $sessionStorage.redirectUrl = ssoAuthView.attributesView.redirectUrl;
        }
        if (organization && organization.shortName === 'BSC') {
          authenticationRouter.markRequirementComplete('sso.landing');
          authenticationRouter.markRequirementComplete('sso.password');
        }
        onboardingRouter.goToNextStep();
      }, function (err) {
        onboardingRouter.ssoMapLoginError(err, organization);
      });
    }

    function _canNavigate() {
      if (vm.form.$valid) {
        $sessionStorage.ssoAuthView = _updateSsoAuthView();
      }

      return vm.form.$valid;
    }

    function _updateSsoAuthView() {
      var ssoAuthView = $sessionStorage.ssoAuthView;

      // Update ssoUserMetadata properties
      ssoAuthView.ssoUserMetadata.hasAcceptedTerms = true;
      ssoAuthView.ssoUserMetadata.isSubjectToGDPR = vm.isSubjectToGDPR;
      ssoAuthView.ssoUserMetadata.isOptedIntoEmail = vm.gdprCheckboxEmailOptIn;

      return ssoAuthView;
    }

    function _checkForSSOPasswordRequiredFeature(features) {
      // Must match enum id hardcoded in API : ProviderPreferenceType
      var SSO_PASSWORD_REQUIRED_PROVIDER_PREFERENCE_TYPE_ID = 7;
      return features.reduce(function (acc, feature) {
        if (acc === false && feature.providerPreferenceType && feature.providerPreferenceType.id === SSO_PASSWORD_REQUIRED_PROVIDER_PREFERENCE_TYPE_ID && feature.value && (feature.value === true || feature.value.toLowerCase() === 'true')) {
          acc = true;
        }
        return acc;
      }, false);
    }
  }
})();